import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { GlobalService } from './global.service';
import { LogService } from './log.service';
import { Dupe } from '../models/dupe.model';
import { AddUserToken, UpdateUserToken } from '../models/user-token.model';
import { GetPointSystemDto, MemberPoints, MemberPointsDto, PointDetail, PointSystem } from 'src/app/admin/point-system/point.system.model';
import { AddPoint } from 'src/app/core/add-point-transaction/add-point.system.model';

@Injectable({ providedIn: 'root' })
export class PointService {
  apiHost: string = environment.apiHost;

  constructor(
    private http: HttpClient,
    private logService: LogService
  ) {}

  GetMemberPointInfo(currentUser: string, memberId: number, self: boolean): Promise<MemberPointsDto> {
    let promise = new Promise<MemberPointsDto>((resolve, reject) => {
      return this.http
        .get<MemberPointsDto>(
          this.apiHost +
            '/Point/GetMemberPointInfo?CurrentUser=' + currentUser +'&MemberId=' + memberId + '&Self=' + self           
        )
        .toPromise() 
        .then( 
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Point: get point info', msg);
            reject('Please check your connection!');
          }
        );
    });
    return promise;
  } 

  GetPointSystems(): Promise<PointSystem[]> {
    let promise = new Promise<PointSystem[]>((resolve, reject) => {
      return this.http
        .get<PointSystem[]>(
          this.apiHost +
            '/Point/GetPointSystems'
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Point: Get Point Systems', msg);
            reject('Please check your connection!');
          }
        );
    });
    return promise;
  }  

  GetPointSystem(systemId: number): Promise<GetPointSystemDto> {
    let promise = new Promise<GetPointSystemDto>((resolve, reject) => {
      return this.http
        .get<GetPointSystemDto>(
          this.apiHost +
            '/Point/GetPointSystem?systemId=' + systemId
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Point: Get Point System', msg);
            reject('Please check your connection!');
          }
        );
    });
    return promise;
  } 
  
  GetDataToDownload(systemId: number): Promise<MemberPoints[]>{
    let promise = new Promise<MemberPoints[]>((resolve, reject) => {
      return this.http
        .get<MemberPoints[]>(
          this.apiHost +
            '/Point/GetDataToDownload?systemId=' + systemId
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Point: Get Point System', msg);
            reject('Please check your connection!');
          }
        );
    });
    return promise;
  }

  AddPointsToMember(addPoint: AddPoint): Promise<boolean> {
    let promise = new Promise<boolean>((resolve, reject) => {
      return this.http
        .post<boolean>(
          this.apiHost +
            '/Point/AddPointsToMember'
            ,
            addPoint
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: add point to member', msg);
            reject('Please check your connection!');
          }
        );
    });
    return promise;
  }

  addSystem(pointSystem: PointSystem): Promise<PointSystem> {
    let promise = new Promise<PointSystem>((resolve, reject) => {
      return this.http
        .post<PointSystem>(
          this.apiHost +
            '/Point/AddSystem'
            ,
            pointSystem
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: add point system', msg);
            reject('Please check your connection!');
          }
        );
    });
    return promise;
  }  

  saveDetails(pointDetail: PointDetail): Promise<PointDetail> {
    let promise = new Promise<PointDetail>((resolve, reject) => {
      return this.http
        .post<PointDetail>(
          this.apiHost +
            '/Point/saveDetails'
            ,
            pointDetail
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: save point system detail', msg);
            reject('Please check your connection!');
          }
        );
    });
    return promise;
  }

  deleteDetails(activityId: number): Promise<PointDetail> {
    let promise = new Promise<PointDetail>((resolve, reject) => {
      return this.http
        .post<PointDetail>(
          this.apiHost +
            '/Point/deleteDetails?DetailId=' + activityId
            ,
            null
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: delete point system detail', msg);
            reject('Please check your connection!');
          }
        );
    });
    return promise;
  }  

  updateSystem(pointSystem: PointSystem): Promise<PointSystem> {
    let promise = new Promise<PointSystem>((resolve, reject) => {
      return this.http
        .post<PointSystem>(
          this.apiHost +
            '/Point/UpdateSystem'
            ,
            pointSystem
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: update point system', msg);
            reject('Please check your connection!');
          }
        );
    });
    return promise;
  }    

  deleteSystem(systemId: number): Promise<any> {
    let promise = new Promise<any>((resolve, reject) => {
      return this.http
        .post<any>(this.apiHost + '/Point/DeleteSystem?systemId=' + systemId, null)
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog(
                'Admin: Delete system ' + systemId.toString(),
                msg
              );
            reject(msg);
          }
        );
    });
    return promise;
  }

  undeleteSystem(systemId: number): Promise<any> {
    let promise = new Promise<any>((resolve, reject) => {
      return this.http
        .post<any>(this.apiHost + '/Point/UndeleteSystem?systemId=' + systemId, null)
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog(
                'Admin: Undelete System ' + systemId.toString(),
                msg
              );
            reject(msg);
          }
        );
    });
    return promise;
  }  
}  
